import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';

export default function Komisyonlar() {
  const { profil } = useAuth();
  const [temsilciler, setTemsilciler] = useState([]);
  const [seciliTemsilci, setSeciliTemsilci] = useState('');
  const [komisyonlar, setKomisyonlar] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [odemeler, setOdemeler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [odemeModal, setOdemeModal] = useState(false);
  const [odemeForm, setOdemeForm] = useState({ tutar: '', not_: '' });
  const [tarihBas, setTarihBas] = useState('');
  const [tarihBit, setTarihBit] = useState('');
  const [tanimModal, setTanimModal] = useState(false);
  const [tanimForm, setTanimForm] = useState({ firma_id: '', oran: '' });
  const [tab, setTab] = useState('detay');

  useEffect(() => {
    fetchFirmalar();
    if (profil?.rol === 'temsilci') { setSeciliTemsilci(profil.id); }
    else { fetchTemsilciler(); }
  }, []);

  useEffect(() => { if (seciliTemsilci) fetchKomisyonlar(); }, [seciliTemsilci, tarihBas, tarihBit]);

  async function fetchFirmalar() { const { data } = await supabase.from('firmalar').select('id, ad').eq('aktif', true); setFirmalar(data || []); }
  async function fetchTemsilciler() { const { data } = await supabase.from('kullanicilar').select('id, ad, soyad').in('rol', ['temsilci', 'admin']).eq('aktif', true); setTemsilciler(data || []); }

  async function fetchKomisyonlar() {
    setLoading(true);
    let q = supabase.from('siparisler').select('*, firmalar(ad)').eq('temsilci_id', seciliTemsilci).not('siparis_durumu', 'eq', 'iptal');
    if (tarihBas) q = q.gte('created_at', tarihBas);
    if (tarihBit) q = q.lte('created_at', tarihBit + 'T23:59:59');
    const { data: s } = await q;
    const { data: o } = await supabase.from('komisyon_odemeleri').select('*').eq('temsilci_id', seciliTemsilci).order('created_at', { ascending: false });
    setKomisyonlar(s || []);
    setOdemeler(o || []);
    setLoading(false);
  }

  const toplamHakEdilen = komisyonlar.reduce((a, s) => a + (s.toplam_komisyon || 0), 0);
  const toplamOdenen = odemeler.reduce((a, o) => a + (o.tutar || 0), 0);
  const bekleyen = toplamHakEdilen - toplamOdenen;

  const firmaKomisyon = firmalar.map(f => ({ firma: f.ad, tutar: komisyonlar.filter(s => s.firma_id === f.id).reduce((a, s) => a + (s.toplam_komisyon || 0), 0) })).filter(f => f.tutar > 0);

  async function handleOdeme() {
    if (!seciliTemsilci || !odemeForm.tutar) return;
    await supabase.from('komisyon_odemeleri').insert({ temsilci_id: seciliTemsilci, tutar: parseFloat(odemeForm.tutar), not_: odemeForm.not_, created_by: profil?.id });
    setOdemeModal(false);
    fetchKomisyonlar();
  }

  async function handleTanimKaydet() {
    if (!tanimForm.firma_id || !tanimForm.oran) return;
    await supabase.from('komisyon_tanimlar').upsert({ temsilci_id: seciliTemsilci, firma_id: tanimForm.firma_id, oran: parseFloat(tanimForm.oran) }, { onConflict: 'temsilci_id,firma_id' });
    setTanimModal(false);
  }

  const fmt = v => (v || 0).toLocaleString('tr-TR');

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Komisyonlar</h1>
        {profil?.rol !== 'temsilci' && seciliTemsilci && (
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-ghost btn-sm" onClick={() => { setTanimForm({ firma_id: '', oran: '' }); setTanimModal(true); }}>Oran</button>
            <button className="btn btn-primary btn-sm" onClick={() => { setOdemeForm({ tutar: bekleyen.toFixed(2), not_: '' }); setOdemeModal(true); }}>💰 Ödeme</button>
          </div>
        )}
      </div>

      {profil?.rol !== 'temsilci' && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div className="form-group">
            <label className="label">Temsilci</label>
            <select className="select" value={seciliTemsilci} onChange={e => setSeciliTemsilci(e.target.value)}>
              <option value="">Temsilci Seçin</option>
              {temsilciler.map(t => <option key={t.id} value={t.id}>{t.ad} {t.soyad}</option>)}
            </select>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <div className="form-group">
              <label className="label">Başlangıç</label>
              <input type="date" className="input" value={tarihBas} onChange={e => setTarihBas(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="label">Bitiş</label>
              <input type="date" className="input" value={tarihBit} onChange={e => setTarihBit(e.target.value)} />
            </div>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={() => { setTarihBas(''); setTarihBit(''); }}>Temizle</button>
        </div>
      )}

      {seciliTemsilci && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 12 }}>
            <div className="stat-card"><div className="stat-label">Hak Edilen</div><div className="stat-value" style={{ color: 'var(--yellow)', fontSize: 16 }}>{fmt(toplamHakEdilen)} ₺</div></div>
            <div className="stat-card"><div className="stat-label">Ödenen</div><div className="stat-value" style={{ color: 'var(--green)', fontSize: 16 }}>{fmt(toplamOdenen)} ₺</div></div>
            <div className="stat-card"><div className="stat-label">Bekleyen</div><div className="stat-value" style={{ color: bekleyen > 0 ? 'var(--red)' : 'var(--text)', fontSize: 16 }}>{fmt(bekleyen)} ₺</div></div>
          </div>

          {firmaKomisyon.length > 0 && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
              {firmaKomisyon.map(f => (
                <div key={f.firma} style={{ background: 'var(--bg2)', padding: '8px 12px', borderRadius: 'var(--r)', border: '1px solid var(--border)' }}>
                  <div style={{ fontSize: 11, color: 'var(--text2)' }}>{f.firma}</div>
                  <div style={{ fontWeight: 700, color: 'var(--yellow)', fontSize: 14 }}>{fmt(f.tutar)} ₺</div>
                </div>
              ))}
            </div>
          )}

          <div className="tabs">
            <button className={`tab-btn ${tab === 'detay' ? 'active' : ''}`} onClick={() => setTab('detay')}>Komisyon Detayı</button>
            <button className={`tab-btn ${tab === 'odeme' ? 'active' : ''}`} onClick={() => setTab('odeme')}>Ödeme Geçmişi</button>
          </div>

          {tab === 'detay' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {loading ? <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Yükleniyor...</div>
                : komisyonlar.length === 0 ? <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Komisyon kaydı yok</div>
                : komisyonlar.map(s => (
                  <div key={s.id} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span className="mono" style={{ color: 'var(--accent)', fontWeight: 700 }}>{s.siparis_no}</span>
                      <span style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(s.created_at).toLocaleDateString('tr-TR')}</span>
                    </div>
                    <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 4 }}>{s.firmalar?.ad}</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 13 }}>{fmt(s.toplam_tutar)} ₺</span>
                      <span style={{ fontWeight: 700, color: 'var(--yellow)' }}>{fmt(s.toplam_komisyon)} ₺ kom.</span>
                    </div>
                  </div>
                ))}
            </div>
          )}

          {tab === 'odeme' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {odemeler.length === 0 ? <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Ödeme yok</div>
                : odemeler.map(o => (
                  <div key={o.id} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <div style={{ fontWeight: 700, color: 'var(--green)', fontSize: 16 }}>{fmt(o.tutar)} ₺</div>
                      <div style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(o.odeme_tarihi || o.created_at).toLocaleDateString('tr-TR')}</div>
                    </div>
                    {o.not_ && <div style={{ fontSize: 12, color: 'var(--text2)' }}>{o.not_}</div>}
                  </div>
                ))}
            </div>
          )}
        </>
      )}

      {odemeModal && (
        <div className="modal-overlay" onClick={() => setOdemeModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Komisyon Ödemesi</h3>
            <div className="form-group"><label className="label">Tutar (₺)</label><input className="input" type="number" value={odemeForm.tutar} onChange={e => setOdemeForm(f => ({ ...f, tutar: e.target.value }))} /></div>
            <div className="form-group"><label className="label">Not</label><input className="input" value={odemeForm.not_} onChange={e => setOdemeForm(f => ({ ...f, not_: e.target.value }))} placeholder="Ödeme notu..." /></div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setOdemeModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleOdeme}>✓ Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {tanimModal && (
        <div className="modal-overlay" onClick={() => setTanimModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Komisyon Oranı Tanımla</h3>
            <div className="form-group"><label className="label">Firma</label><select className="select" value={tanimForm.firma_id} onChange={e => setTanimForm(f => ({ ...f, firma_id: e.target.value }))}><option value="">Firma Seçin</option>{firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}</select></div>
            <div className="form-group"><label className="label">Komisyon Oranı (%)</label><input className="input" type="number" step="0.01" value={tanimForm.oran} onChange={e => setTanimForm(f => ({ ...f, oran: e.target.value }))} placeholder="20.00" /></div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setTanimModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleTanimKaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
